const { normalizeCommasEnvironment } = require('./commas-integration-form');

const COMMAS_ENVIRONMENTS = Object.freeze([
  Object.freeze({ value: 'sandbox', label: 'Sandbox (test payments)' }),
  Object.freeze({ value: 'production', label: 'Production (live payments)' })
]);

const CommasEnvironmentSelect = {
  name: 'CommasEnvironmentSelect',
  props: {
    value: { default: '' },
    attribute: { type: String, default: 'Environment' },
    validator: { default: null }
  },
  render(h) {
    const value = normalizeCommasEnvironment(this.value);
    const valid = COMMAS_ENVIRONMENTS.some(option => option.value === value);
    return h('select', {
      attrs: {
        'aria-label': this.attribute,
        'aria-invalid': this.validator && this.validator.$error ? 'true' : 'false',
        required: true
      },
      domProps: { value: valid ? value : '' },
      style: {
        width: '100%', minHeight: '40px', padding: '8px 12px',
        border: '1px solid var(--gs-border, #d1d5db)', borderRadius: '6px',
        background: 'var(--gs-surface, #fff)', color: 'var(--gs-foreground, #374151)'
      },
      on: {
        change: event => {
          const selected = event.target.value;
          if (COMMAS_ENVIRONMENTS.some(option => option.value === selected)) {
            this.$emit('input', selected);
            if (this.validator && this.validator.$touch) this.validator.$touch();
          }
        },
        blur: () => { if (this.validator && this.validator.$touch) this.validator.$touch(); }
      }
    }, [
      h('option', { attrs: { value: '', disabled: true }, domProps: { selected: !valid } }, 'Choose an environment'),
      ...COMMAS_ENVIRONMENTS.map(option => h('option', {
        key: option.value, attrs: { value: option.value }, domProps: { selected: option.value === value }
      }, option.label))
    ]);
  }
};

// The installed account modal renders every catalog field as TextInput. Scope
// the replacement to that modal's Commas environment field; delegate every
// other input to the original component with its bindings/listeners untouched.
function createCommasEnvironmentInput(OriginalTextInput) {
  return {
    name: 'AccountGatewayTextInput',
    functional: true,
    inject: { commasGatewayModal: { default: null } },
    render(h, context) {
      const modal = context.injections.commasGatewayModal;
      const environment = modal && (modal.formfields || []).find(field => field.key === 'environment');
      const isEnvironment = modal && modal.selectedIntegrationType === 'commas'
        && environment && context.props.attribute === environment.label;
      return h(isEnvironment ? CommasEnvironmentSelect : OriginalTextInput,
        context.data, context.children);
    }
  };
}

module.exports = { COMMAS_ENVIRONMENTS, CommasEnvironmentSelect, createCommasEnvironmentInput };
